<template>
  <div class="infos-article-card">
    <div class="header-blue">
      <div class="header-main">
        <span class="code-article">Code article : <strong>{{ codeArticle }}</strong></span>
        <span class="designation-main" v-if="designation && designation.trim() !== '' && designation.trim() !== 'empty'">{{ designation }}</span>
      </div>
      <div class="designation-secondary">
        <span v-if="designation2 && designation2.trim() !== '' && designation2.trim() !== 'empty'">{{ designation2 }}</span>
        <span v-if="designation3 && designation3.trim() !== '' && designation3.trim() !== 'empty'">{{ designation3 }}</span>
      </div>
    </div>
    <div class="infos-article-content row">
      <div class="col-lg-6 col-12 infos-left">
        <div class="chips-row">
          <span class="chip stock" :class="{'chip-danger': infos[0] && infos[0].qte - calculerSomme() < 0, 'chip-success': infos[0] && infos[0].qte - calculerSomme() > 0, 'chip-warning': infos[0] && infos[0].qte - calculerSomme() == 0}">
            Stock : <strong>{{ infos[0] ? infos[0].qte : '-' }}</strong>
          </span>
          <span class="chip besoin">
            Total besoins : <strong>{{ calculerSomme().toFixed(1) }}</strong>
          </span>
          <span class="chip dispo" :class="{'chip-danger': infos[0] && infos[0].qte - calculerSomme() < 0, 'chip-success': infos[0] && infos[0].qte - calculerSomme() > 0, 'chip-warning': infos[0] && infos[0].qte - calculerSomme() == 0}">
            Stock (après besoins) : <strong>{{ infos[0] ? (infos[0].qte - calculerSomme()).toFixed(1) : '-' }}</strong>
          </span>
        </div>
        <div class="besoins-encart" v-if="quantiteAffaires.length !== 0">
          <h3>Besoins actuels affaires</h3>
          <div class="infoAffaires" v-for="quantiteAffaire in quantiteAffaires" :key="quantiteAffaire.id">
            <span class="chip affaire">Affaire <strong>{{ quantiteAffaire.naf }}</strong> : {{ quantiteAffaire.qte }} pièce(s)</span>
            <span class="chip delais">Délais : {{ formatDate(quantiteAffaire.delais) }}</span>
            <span class="chip commande">Commande client : {{ quantiteAffaire.cocde }}</span>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12 infos-right">
        <div class="chips-row">
          <span class="chip">Fournisseur : <strong>{{ infos[0] ? infos[0].nom : '-' }}</strong></span>
          <span class="chip">Magasin : <strong>{{ infos[0] ? infos[0].nom_magasins : '-' }}</strong></span>
          <span class="chip">Inventaire : <strong>{{ infos[0] ? formatDate(infos[0].date_inventaire) : '-' }}</strong></span>
        </div>
        <div class="photo-article-encart mt-3">
          <h3>Photo de l'article</h3>
          <div v-if="confirmationMessage" class="alert alert-success" role="alert">
            {{ confirmationMessage }}
          </div>
          <div v-if="erroMessage" class="alert alert-danger" role="alert">
            {{ erroMessage }}
          </div>
          <form v-if="fichiersDisplay.length === 0 || loggedInRole !== 'production'"  @submit.prevent="submit" class="upload-form">
            <input id="file" type="file" @change="addFichiers" accept="image/*,.pdf,.igs,.prt,.vcf,.step,.stp" capture required>
            <label for="file" class="btn-upload"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
              <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
            </svg>Choisir un fichier</label>
            <input type="hidden" id="nomFichier" v-model="nomFichier">
            <input type="hidden" id="utilisateur" v-model="utilisateur" required>
            <input type="hidden" id="codeArticle" v-model="codeArticle" required>
            <button type="submit" class="btn-upload-submit"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-plus-fill" viewBox="0 0 16 16">
            <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8.5 7v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 1 0z"/>
            </svg>Ajouter la photo</button>
          </form>
          <div class="fichiers-list mt-2">
            <div v-for="(fichier, index) in fichiersDisplay" :key="index" class="fichier-item">
              <img class="photo-article" :src="fichier.fichiers" alt="photo-article">
              <span v-if="loggedInRole !== 'production'" @click="deleteFile(fichier.fichiers)" class="btn-remove"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
              <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>Supprimer</span>
            </div>
          </div>
        </div>
        <div v-if="loggedInRole=='admin' || loggedInRole === 'client'" class="code mt-3">
          <h3>Code client</h3>
          <form @submit.prevent="submit2" class="code-form">
            <input type="text" id="code" v-model="code" placeholder="Code client">
            <input type="hidden" id="utilisateur" v-model="utilisateur" required>
            <input type="hidden" id="codeArticle" v-model="codeArticle" required>
            <button type="submit" class="btn-upload-submit"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-plus-fill" viewBox="0 0 16 16">
            <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8.5 7v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 1 0z"/>
            </svg>Ajouter le code</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/components/axiosConfig.js'
import VueCookies from 'vue-cookies'


export default {
  data() {
    return {
      infos: [],
      nomFichier: 'photo-article',
      loggedInRole: null,
      quantiteAffaires: [],
      designation: null,
      designation2: null,
      designation3: null,
      codeArticle: null,
      utilisateur: '',
      fichiers: [],
      confirmationMessage: '',
      erroMessage: '',
      fichiersDisplay: [],
      code: '',
      email: '',
    }
  },
  created() {
    this.designation = this.$route.params.designation;
    this.designation2 = this.$route.params.designation2;
    this.designation3 = this.$route.params.designation3;
    this.codeArticle = this.$route.params.codeArticle;
  
  },
  mounted() { 
    const nom = VueCookies.get('nom')
    if (nom) {
        this.utilisateur = nom
    }
    const email = VueCookies.get('email')
    if (email) {
        this.email = email
    }
   

    axios.get(`https://www.simef.fr/espace-client/api/getInfosArticle.php?codeArticle=${this.codeArticle}`)
      .then(response => {
        this.infos = response.data;
      })
      .catch(error => {
        console.error(error);
        
      });


      axios.get(`https://www.simef.fr/espace-client/api/getAffairesQuantite.php?codeArticle=${this.codeArticle}`)
      .then(response => {
        this.quantiteAffaires = Array.isArray(response.data) ? response.data : [];
      })
      .catch(error => {
        // Some backend responses incorrectly use HTTP 500 with a valid JSON payload.
        const fallbackData = error?.response?.data;
        if (Array.isArray(fallbackData)) {
          this.quantiteAffaires = fallbackData;
          return;
        }
        console.error(error);
      });


      // Récupération des fichiers
      axios.post('https://www.simef.fr/espace-client/api/getFichiersArticles.php', {
        codeArticle: this.codeArticle,
        name: "photo-article.jpg"
      })
      .then(response => {
          this.fichiersDisplay = response.data;
      })
      .catch(error => {
          console.log(error);
          
      });

      this.getCode();
  }, 
  methods: {
    formatDate(date) {
      // Extraire les parties de la date
      const year = date.substr(0, 4);
      const month = date.substr(4, 2);
      const day = date.substr(6, 2);

      // Concaténer les parties dans l'ordre souhaité
      const formattedDate = `${day}-${month}-${year}`;

      // Renvoyer la date formatée
      return formattedDate;
    },
    calculerSomme() {
      let somme = 0;
      for (let i = 0; i < this.quantiteAffaires.length; i++) {
        const qte = parseFloat(this.quantiteAffaires[i].qte, 10);
        somme += qte;
      }
      return somme;
    },
    submit() {
      // Create a new FormData object
      const formData = new FormData();

      // Ajouter les fichiers au formulaire
      for (let i = 0; i < this.fichiers.length; i++) {
          formData.append('fichiers[]', this.fichiers[i]);
      }
      // Add the user and chantier information to the form data
      formData.append('nomFichier', this.nomFichier);
      formData.append('utilisateur', this.utilisateur);
      formData.append('codeArticle', this.codeArticle);

      // Make the API request
      axios.post('https://www.simef.fr/espace-client/api/ajoutFichiers.php', formData)
      .then(response => {
          // Handle the response from the server
          this.confirmationMessage = response.data.success;
          this.erroMessage = response.data.error;
          this.fichiers = [];

          // Retrieve the updated list of files after successful upload
          this.getFichiersDisplay();
      })
      .catch(error => {
          console.error(error);
          this.refusMessage = "Une erreur est survenue";
      });
    },
    submit2() {
      // Create a new FormData object
      const formData = new FormData();

      // Add the user and chantier information to the form data
      formData.append('codeUnique', this.code);
      formData.append('utilisateur', this.email);
      formData.append('codeArticle', this.codeArticle);

      // Make the API request
      axios.post('https://www.simef.fr/espace-client/api/ajoutCode.php', formData)
      .then(response => {
          // Handle the response from the server
          this.confirmationMessage = response.data.success;
          this.erroMessage = response.data.error;

          // Retrieve the updated list of files after successful upload
          this.getCode();
      })
      .catch(error => {
          console.error(error);
          this.refusMessage = "Une erreur est survenue";
      });
    },
    addFichiers(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
          this.fichiers.push(files[i]);
      }
    },
    deleteFile(url) {
      const confirmation = confirm("Êtes vous sur de vouloir supprimer ce fichier ?");
      const nomImage = url.substring(url.lastIndexOf("/") + 1);
      if (confirmation) {
        axios.post('https://www.simef.fr/espace-client/api/deleteFiles.php', {
          url: url,
          nomImage: nomImage,
          codeArticle: this.codeArticle
        })
        .then(response => {
          // Remove the deleted file from the `fichiers` array
          this.fichiers = this.fichiers.filter(fichier => fichier.fichiers.indexOf(url) === -1);
          console.log(response)

          // Retrieve the updated list of files after successful deletion
          this.getFichiersDisplay();
        })
        .catch(error => {
          console.error('Error deleting file:', error);
        });
      }
     
    },
    getFichiersDisplay() {
      axios.post('https://www.simef.fr/espace-client/api/getFichiersArticles.php', {
          codeArticle: this.codeArticle,
          name: "photo-article.jpg"
        })
        .then(response => {
          this.fichiersDisplay = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getCode() {
      axios.post('https://www.simef.fr/espace-client/api/getCodesArticles.php', {
          codeArticle: this.codeArticle,
          email: this.email
        })
        .then(response => {
          this.code = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
  
  }

  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$primary: #2b358d;
.infos-article-card {
  background: #fff;
  border: 1px solid #cbcbcb;
  border-radius: 0px;
  margin-bottom: 30px;
  box-shadow: 0 4px 16px rgba(43,53,141,0.06);
}
.header-blue {
  background: $primary;
  color: #fff;
  padding: 18px 28px 10px 28px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  .header-main {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    font-size: 1.1rem;
    .code-article {
      font-weight: 700;
      font-size: 1.1rem;
    }
    .designation-main {
      font-size: 1.1rem;
      font-weight: 600;
      margin-left: 18px;
    }
  }
  .designation-secondary {
    font-size: 1rem;
    font-weight: 500;
    margin-top: 2px;
    opacity: 0.85;
    span {
      margin-right: 10px;
    }
  }
}
.infos-article-content {
  padding: 28px 28px 18px 28px;
}
.chips-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 18px;
}
.chip {
  background: #f5f5f5;
  border-radius: 12px;
  padding: 5px 14px;
  font-size: 0.98rem;
  color: #1d1d20;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 3px;
  &.stock {
    background: #eaf1fb;
    color: $primary;
  }
  &.besoin {
    background: #fffbe6;
    color: #bfa100;
  }
  &.dispo {
    background: #eaf1fb;
    color: $primary;
  }
  &.chip-danger {
    background: #fdeaea;
    color: #d32f2f;
  }
  &.chip-success {
    background: #e6fbe6;
    color: #388e3c;
  }
  &.chip-warning {
    background: #fffbe6;
    color: #bfa100;
  }
}
.besoins-encart {
  border: 1px solid lightgrey;
    padding: 15px;
    background: #f2f2f2 !important;
  max-height: 320px;
  overflow-y: auto;
  h3 {
    font-size: 1.08rem;
    font-weight: 700;
    margin-bottom: 10px;
  }
  .infoAffaires {
    margin-bottom: 12px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    background: #fff;
    padding: 6px;
    border-radius: 16px;
  }
}
.photo-article-encart {
  border: 1px solid lightgrey;
  padding: 15px;
  background: #f2f2f2 !important;
  h3 {
    font-size: 1.08rem;
    font-weight: 700;
    margin-bottom: 10px;
  }
  .photo-article {
    width: 100%;
    max-width: 320px;
    border-radius: 8px;
    margin-bottom: 10px;
    box-shadow: 0 2px 8px rgba(43,53,141,0.08);
  }
  .fichiers-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    .fichier-item {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 10px;
      .photo-article {
        width: 120px;
        max-width: 100%;
        border-radius: 8px;
        margin-bottom: 4px;
      }
    }
  }
  .btn-upload, .btn-upload-submit {
    color: #fff;
    border: none;
    padding: 8px 18px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    cursor: pointer;
    transition: background 0.2s;
    text-align: left;
    justify-content: flex-start;
    svg {
      margin-right: 5px;
    }
    &:hover {
      background: #1d1d20;
    }
  }
}
.btn-upload-submit {
  margin-top: 5px!important;
}
.code-form {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  input[type="text"] {
    padding: 7px 12px;
    border: 1px solid #cbcbcb;
    border-radius: 8px;
    font-size: 1rem;
  }
}
.btn-remove {
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-top: 10px;
  color: $primary;
  font-weight: 500;
  svg {
    margin-right: 5px;
    height: 12px;
    width: 12px;
    path {
      fill: $primary;
    }
  }
}
@media (max-width: 991px) {
  .infos-article-content {
    padding: 18px 8px 8px 8px;
  }
  .header-blue {
    padding: 12px 10px 8px 10px;
  }
}
</style>
